import { fabric } from "fabric"
import createDynamicFabricClass from "./createDynamicFabricClass"

const DynamicStrokeCircle = createDynamicFabricClass(fabric.Circle, 'dynamicCircle')

export default DynamicStrokeCircle